<p-dialog id="videoDialog" [baseZIndex]="1000" [modal]="true" [(visible)]="displayModal" (onHide)="closeDialog()"
  [contentStyle]="{'overflow':'visible'}" class="video-dialog" header="{{title}}">
  <div style="width: 100%; height: 100% !important;">
    <iframe style="width: 100%; height: 100%;" [src]="videoUrl | safe" allow="autoplay;" frameborder="0"
      allowfullscreen></iframe>
  </div>
</p-dialog>